import React from "react";

import "./PDPA.scss";

export default function PDPA() {
  return (
    <div className="PDPA__mainWrapper">
      <div className="PDPA__contentWrapper">
        Updated: Dec 2021
        <h1>KAYE TRANSPORT SERVICE PTE LTD DATA PROTECTION POLICY</h1>
        <h1>Background</h1>
        <p>
          This Data Protection Policy describes how the KAYE TRANSPORT SERVICE
          PTE LTD, hereinafter known referred to as “KAYE”, subscribes to the
          principle, guidelines and requirements of the Personal Data Protection
          Act 2012 which commenced on 2nd July 2014.
        </p>
        <p>
          Notwithstanding references to KAYE, any obligation in this policy,
          where stated will only extend to the relevant entity KAYE that is
          providing the service to the individual or is otherwise in control and
          possession of the Personal Data.
        </p>
        <p>
          We will continue to review this policy and all privacy-related
          information made publicly available by KAYE, to ensure it is relevant
          and remains current with changing laws and regulations, as well as the
          evolving needs of KAYE.
        </p>
        <h1>Applicability</h1>
        <p>The scope and application of this Policy is as follows:</p>
        <p>
          • This policy applies to entities within KAYE that is offering
          Services, and collecting, using or disclosing the Personal Data; to
          the extent as may be required by the Act.
        </p>
        <p>• This Policy covers all practices regarding Personal Data.</p>
        <p>
          • This Policy applies to all individuals. Any individual who holds the
          account with the relevant entity within KAYE must ensure that all end
          users under the same account understand and agree to this Policy.
        </p>
        <p>
          • The application of this Policy is subject to applicable Laws, and to
          the extent that any Laws pre-existing the Act apply, such pre-existing
          Laws may supersede the applicability of the Act in the event of
          inconsistency, to the extent stipulated under the Act.
        </p>
        <p>
          • This policy does not supersede or replace any earlier consents you
          may have provided to KAYE, and this Policy supplements all such
          pre-existing consents concerning the collection, disclosure and/or use
          of your Personal Data.
        </p>
        <h1>Policy Provisions</h1>
        <h1>1. Data Protection Officers (DPO)</h1>
        <p>
          1.1 The DPO have been appointed to oversee compliance with the Act.
          Other employees within KAYE may be delegated to act on behalf of the
          DPO or to take responsibility for the day-to-day collection and
          processing of Personal Data.
        </p>
        <p>
          {" "}
          1.2 KAYE shall make known, upon request, the title of the person or
          persons designated as DPO.
        </p>
        <p>The DPO may be contactable by the following ways;</p>
        <pre>Write in: Data Protection Officer</pre>
        <pre> Ling Wei Transport Service Pte Ltd</pre>
        <pre>Address: 4 Highgate Walk</pre>
        <pre>Singapore 598755</pre>
        <pre>Email: lingweitpt@gmail.com</pre>
        <h1>2. Collecting of Personal Data</h1>
        <p>
          2.1 Personal Data may be collected from you, your spouse and your
          children’s in the following ways:
        </p>
        <p>
          • Upon completing a service application form through our online
          registration System.
        </p>
        <p>
          • Any Individual who log in to our website, using technologies such as
          cookies.
        </p>
        <p>
          • We obtain it from other sources, such as employers, law enforcement
          agencies and/or other Public Agency.
        </p>
        <p>• We obtain it from other entities within KAYE.</p>
        <p>• We collect it by other lawful means.</p>
        <p>
          2.2 Unless permitted by Laws, KAYE shall not collect Personal Data
          without the consent of the Individual.
        </p>
        <p>
          2.3 Customer who volunteers Personal Data of another person to KAYE
          also warrants and represents to KAYE that he/she is authorized by such
          other person to disclose such Personal Data to us, and that such
          Personal Data is accurate and complete.
        </p>
        <p>
          • By providing Personal Data relating to a third party (such as
          information of your spouse, children or guardian) you represent and
          warrant that the consent of that third party has been obtained for the
          collection, use and disclosure of the personal data for purpose
          related to transportation services.
        </p>
        <p>
          {" "}
          2.4 Personal Data can also be images captured on CCTVs installed on
          our school buses
        </p>
        <p>
          • CCTV recordings may be shared with the management of The Winstedt
          School for the purpose of investigation and clarifications (including
          disciplinary matters)
        </p>
        <p>
          • Appropriate notices are displayed in areas of surveillance,
          including school buses
        </p>
        <h1>3. Purposes for Collection, Use and Disclosure of Personal Data</h1>
        <p>
          {" "}
          3.1 Your Personal Data may be collected, used and/or disclosed for the
          following purposes:
        </p>
        <p>
          • To conduct identity verification, and application processing for
          Service;
        </p>
        <p>• To provide the Service and to facilitate logistic purposes;</p>
        <p>
          • To respond and deal with enquires or complaints and other customer-
          care activities;
        </p>
        <p>
          • To generate bills, facilitate payment of bills, manage accounts and
          debt-recovery functions;
        </p>
        <p>
          • To manage, develop and improve our business and operations to serve
          you better;
        </p>
        <p>
          • To provide self-service channels for customer-care and account
          management activities;
        </p>
        <p>• To carry out customer surveys;</p>
        <p>
          • To conduct investigations or action taken in relation to bad debts,
          crime prevention, risk management, or to prevent you or KAYE from
          harm, illegal or unlawful activities;
        </p>
        <p>
          • To conduct investigations or take action in relation to any
          violation of any of our terms and conditions for Services, including
          our General Bus Handbook;
        </p>
        <p>
          • To third parties who perform Services on our behalf, but only to the
          extent necessary for the Services to be performed;
        </p>
        <p>
          • To protect and maintain the Personal Data and to have access to it
          including for making corrections to the Personal Data;
        </p>
        <p>
          • To comply with legal and regulatory requirements imposed by any
          Public Agency, and otherwise with Laws;
        </p>
        <p>
          • Any other purpose necessary, ancillary or consequential to the above
          specified purposes.
        </p>
        <p>
          3.1 Your Personal Data will be disclosed for the purposes stated above
          to our staffs and employees, third parties, service providers,
          advisors, which includes without limitation, the following individuals
          or entities:
        </p>
        <p>
          • External service providers such as Sub contractors and Bus crew
          members as well as third parties for maintenance and support of the
          Service;
        </p>
        <p>• Banks for the processing of payment;</p>
        <p>
          • Entities within KAYE for provision of services including document
          storage and printing of bills;
        </p>
        <p>• Advisors, including auditors and lawyers who advise us;</p>
        <p>• Any data intermediaries.</p>
        <p>
          3.3 Unless permitted by Laws, KAYE shall not use or disclose the
          Personal Data for any other purpose, without first identifying and
          documenting the other purpose and obtaining the consent of the
          Customer.
        </p>
        <p>
          3.4 Upon request by a Customer, our employees collecting Personal Data
          shall explain this Policy.
        </p>
        <h1>4. Deemed Consent</h1>
        <p>
          4.1 Customers are deemed to have given their consent for the
          collection, use and disclosure of Personal Data in the following
          circumstances:
        </p>
        <p>
          A. When the Customer voluntarily provides his/her Personal Data to us;
        </p>
        <p>
          B. When the Customer is aware of the purposes for which he/she is
          providing his/her Personal Data to us;
        </p>
        <p>
          C. It is reasonable for the Customer to have provided the Personal
          Data to us in any other circumstances where consent is deemed under
          the Act.
        </p>
        <p>
          D. When the Customer voluntarily provides his/her Singapore Telephone
          Number are deemed to have given your consents to contact you, SMS /
          Text messages you in relating to all transportation related matters in
          comply with “Do Not Call provisions”.
        </p>
        <h1>
          5. Limitation for Collecting, Use and Disclosure of Personal Data
        </h1>
        <p>
          5.1 KAYE collects Personal Data primarily from anyone who is our
          customers (including prospective customers). The collection of
          Personal Data is limited to that which is essential for the
          identification as well as Service providing purposes.
        </p>
        <p>
          5.2 Unless permitted by Law, KAYE will not disclose Personal Data to
          other parties or entities for the advertising, promotion or marketing
          of such other party’s products and services, and KAYE will not sell
          for payment of the Personal Data to anyone for any marketing purpose
          without your consent.
        </p>
        <h1>6. Preservation of Personal Data</h1>
        <p>
          6.1 KAYE will collect and retain Personal Data via reasonable controls
          and practices in KAYE’s discretion, for as long as such individual
          remain our customers and for as long as it is necessarily required or
          relevant for business or legal purposes.
        </p>
        <h1>7. Withdrawal of Consent</h1>
        <p>
          7.1 Customers are able to withdrawn their consent to our continued use
          and disclosure of Personal Data as described in this Policy at an
          advance notice period of 2 weeks. Such withdrawal should be done in
          writing to KAYE.
        </p>
        <p>
          7.2 If consent is withdrawn, the Customer acknowledges that KAYE may
          no longer be able to provide the Service. Accordingly, KAYE may,
          insofar as such consent is integral to the provision of the Service,
          cease to provide the Service to the individual. Notwithstanding any
          withdrawal of consent, unless otherwise agreed by KAYE, Customers will
          still be bound by their agreement which include the Terms &amp;
          Conditions for School Transport with the relevant entity in KAYE.
          Should Customer choose to terminate the relevant agreement without
          giving any advance notice of 2 weeks at least, early termination
          charges and/or other charges may apply in accordance with the
          agreement and KAYE reserves its rights thereof.
        </p>
        <p>
          7.3 Customers should also acknowledge that KAYE will reserve its
          rights to use their Personal Data beyond effective withdrawal date on
          administration and financial purposes for any outstanding matters.
        </p>
        <p>
          7.4 Customers may write in to the Office of DPO for more information
          regarding the implications of withdrawing consent.
        </p>
        <h1>8. Protection of Personal Data</h1>
        <p>
          8.1 To the extent required by the Act, KAYE shall protect Personal
          Data in its possession or under its control against risks of
          unauthorized access, collection, use, disclosure, copying,
          modification, disposal, or destruction, through reasonable and
          appropriate measures.
        </p>
        <h1>9. Accuracy and correction of Personal Data</h1>
        <p>
          9.1. To the extent required by the Act, KAYE will use reasonable
          efforts to ensure that the Personal Data it uses is sufficiently
          accurate and complete to minimize the possibility that incorrect
          Personal Data may be used to make a decision that impacts the
          Individual to whom the Personal Data relates, or if such Personal Data
          is likely to be disclosed to a third party. However, you acknowledge
          that there may be circumstances where KAYE is entitled to assume such
          accuracy, in accordance with Laws.
        </p>
        <p>
          9.2 We encourage Customers to inform us when there are any changes to
          the Personal Data which they have provided to KAYE, so as to ensure
          that we are having the most current, accurate and complete
          information. Upon request by the Customer, KAYE may, in accordance
          with the Act, correct or complete any Personal Data found to be
          inaccurate or incomplete as soon as feasible. Save as otherwise
          required under the Act, Customer may only correct any Personal Data
          which he/she has provided to KAYE. KAYE reserve the right to not
          correct Personal Data where permitted under the Act.
        </p>
        <h1>10. Access to Personal Data</h1>
        <p>
          10.1 To the extent required by the Act, upon request, KAYE shall
          provide the Customer with an account of his/her Personal Data which is
          in KAYE’s possession or control. Such information requested for shall
          be provided within a reasonable time to the Customer.
        </p>
        <p>
          10.2 To the extent required by the Act, upon request by the Customer,
          KAYE shall provide information relating to how the Customer’s Personal
          Data has been or may have been used or disclosed within that Academic
          Year before the date of such request. KAYE may also provide a standard
          list of possible third parties as part of its response to all access
          requests for information relating to the disclosure of Personal Data
          during such period, and the same shall suffice as performance of
          KAYE’s obligation in respect thereof. Such information requested for
          shall be provided within a reasonable time to the Customer.
        </p>
        <p>
          10.3 Subject to the Act, KAYE may not be able to provide access to all
          of the Personal Data that they hold about an Individual. For example,
          KAYE may not provide access to Personal Data if such provision could
          reveal Personal Data about another Customer, if such information is
          subject to legal privilege or if such provision will be contrary to
          national interest. If access to Personal Data cannot be provided, the
          reasons for denying such access will be provided upon request, to the
          extent permitted under Laws.
        </p>
        <p>
          10.4 Customers may seek access to their Personal Data by writing in to
          the DPO of KAYE.
        </p>
        <h1>11. Procedures and Practices</h1>
        <p>
          11.1 KAYE has implemented the following procedures to give effect to
          this Policy:
        </p>
        <p>
          • Implementing procedures to protect Personal Data and to oversee
          compliance with the Act; including means to access and/or correct
          Personal Data and to facilitate withdrawal of consent;
        </p>
        <p>
          • Establishing procedures to receive and respond to inquiries or
          complaints in relation to Personal Data;
        </p>
        <p>• Training and communicating to employees about this Policy;</p>
        <p>• Developing public information to explain this Policy;</p>
        <p>• Notifying changes to this policy on KAYE Online System.</p>
        <h1>12. Control of Your Password</h1>
        <p>
          By visiting our website, you are responsible for all actions taken
          with your User ID and password. Therefore we do not recommend that you
          disclose your password to any third parties. If you choose to share
          your User ID and password or your personal information with third
          parties, you are responsible for all actions taken with your account
          and therefore you should review that third party’s privacy policy. If
          you lose control of your password, you may lose substantial control
          over your personal and account information and may subject to legally
          binding actions taken on your behalf. Therefore, if your password has
          been compromised for any reason, you should immediately change your
          password.
        </p>
        <h1>13. General</h1>
        <p>
          13.1 KAYE may revise and/or amend and/or supplement this Policy at its
          discretion from time to time. Such changes will be published on the
          Online System. Customers are advised to check back periodically to
          ensure that they are aware of any such changes. To the fullest extent
          permissible under Laws, you agree to be bound by the prevailing terms
          of this Policy.
        </p>
        <p>
          13.2 Customers acknowledge that in addition to the exceptions under
          the Act, this Policy or pre-existing consents, KAYE may use and
          disclose his/her Personal Data in the following instances without
          consent:
        </p>
        <p>
          • Planning, provisioning and Billing for any Services provided by
          KAYE;
        </p>
        <p>
          • Managing bad debt and prevent fraud related to the provision of any
          Services;
        </p>
        <p>
          • Providing assistance to law enforcement, judicial or other
          government agencies.
        </p>
        <p>
          13.3 To the fullest extent permitted under Laws, KAYE cannot be
          responsible for a third party’s acts, omissions, data policies, nor
          the content or security of any third party websites, even if linked to
          KAYE Online System, and any such liability is expressly disclaimed and
          excluded.
        </p>
        <p>
          13.4 Please view{" "}
          <a href="http://www.pdpc.gov.sg/" target="__blank" rel="noopener">
            http://www.pdpc.gov.sg/
          </a>{" "}
          for more information on the Personal Data Protection Act 2012 or to
          contact the Personal Data Protection Commission (PDPC)
        </p>
      </div>
    </div>
  );
}
